import apiRequest from './client';

export const primeCsrf = () => apiRequest('/auth/csrf/');

// Page de login UNIQUE (/login) pour la company, ses utilisateurs et les
// superviseurs : le serveur reconnait le role au username.
// -> { role: 'company', company } | { role: 'supervisor', supervisor }
export const unifiedLogin = (username, password) =>
  apiRequest('/auth/login/', { method: 'POST', body: { username, password } });

export const companyLogin = (username, password) =>
  apiRequest('/companies/login/', { method: 'POST', body: { username, password } });

export const companyLogout = () => apiRequest('/companies/logout/', { method: 'POST' });

export const getCurrentCompany = () => apiRequest('/companies/me/');

export const superadminLogin = (username, password) =>
  apiRequest('/auth/superadmin/login/', { method: 'POST', body: { username, password } });

export const superadminLogout = () => apiRequest('/auth/superadmin/logout/', { method: 'POST' });

export const getCurrentSuperadmin = () => apiRequest('/auth/superadmin/me/');

// Le superadmin "entre" dans une company : la session bascule sur le portail company
// (droits complets) tout en gardant la session staff. `stopImpersonation` revient.
export const impersonateCompany = (companyId) =>
  apiRequest(`/auth/superadmin/impersonate/${companyId}/`, { method: 'POST' });

export const stopImpersonation = () =>
  apiRequest('/auth/superadmin/impersonate/stop/', { method: 'POST' });

export const supervisorLogin = (username, password) =>
  apiRequest('/banks/supervisor/login/', { method: 'POST', body: { username, password } });

export const supervisorLogout = () => apiRequest('/banks/supervisor/logout/', { method: 'POST' });

export const getCurrentSupervisor = () => apiRequest('/banks/supervisor/me/');

export const subSupervisorLogin = (username, password) =>
  apiRequest('/sub-supervisors/login/', { method: 'POST', body: { username, password } });

export const subSupervisorLogout = () => apiRequest('/sub-supervisors/logout/', { method: 'POST' });

export const getCurrentSubSupervisor = () => apiRequest('/sub-supervisors/me/');
